<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <b-container>
        <b-row v-if="apiError">
            <b-col>
                <b-alert variant="warning" show>{{apiError}}</b-alert>
            </b-col>
        </b-row>
        <spinner v-if="busy"></spinner>
        <b-row v-else>
            <b-col>
                <b-button class="float-right mb-2" v-b-modal.templateModal
                          @click.stop="$refs.templateModal.manageEntity()">
                    <i class="fal fa-plus"></i> New
                </b-button>
                <b-table responsive striped hover small :items="templateList"
                         :fields="['id', 'label', 'name', 'meta', { key: 'actions', class: 'table-action-column' }]">
                    <template v-slot:cell(actions)="row">
                        <b-button variant="link" v-b-modal.templateModal
                                  @click.stop="$refs.templateModal.manageEntity(row.item)">
                            <i class="fal fa-edit"></i></b-button>
                        <b-button variant="link" @click.stop="deleteTemplate(row.item)">
                            <i class="fal fa-trash-alt"></i>
                        </b-button>
                    </template>
                </b-table>
            </b-col>
        </b-row>
        <template-modal
                @saved="loadTemplateList"
                ref="templateModal"
                id="templateModal">
        </template-modal>
    </b-container>
</template>

<script>

    import TemplateApi from "@shared/_api/cms/template";
    import TemplateModal from "./TemplateModal";
    import Spinner from "../../../viewsShop/components/ui/Spinner";

    export default {
        name: 'Template',
        components: {
            "template-modal": TemplateModal,
            'spinner': Spinner
        },
        data() {
            return {
                busy: false,
                apiError: null,
                templateList: []
            };
        },
        methods: {
            loadTemplateList: function () {
                this.busy = true;
                TemplateApi.get().then((templateList) => {
                    this.templateList = templateList;
                }).catch(error => {
                    this.apiError = error;
                }).finally(() => {
                    this.busy = false;
                })
            },
            deleteTemplate(template) {
                this.busy = true;
                TemplateApi.delete(template.id).catch(error => {
                    this.apiError = error;
                }).finally(() => {
                    this.busy = false;
                    this.loadTemplateList();
                });
            },
        },
        created() {
            this.loadTemplateList();
        }
    }

</script>